import { UIText3 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './SystemInfoBubble.css';

type TProps = {
  text: React.ReactNode;
};

export const SystemInfoBubble: React.FC<TProps> = ({ text }) => {
  return (
    <div className={styles['container']}>
      <div className={styles['text']}>
        <UIText3 color="text-secondary-default">{text}</UIText3>
      </div>
    </div>
  );
};
